<template>
  <!-- 单页预览页面 -->
  <div id="about-intd">
    <pub-head></pub-head>
    <pubs-nav></pubs-nav>
    <div class="intd-box">
      <el-alert title="提示：该页面为单页新闻预览页面~" style="margin:50px 0px" type="info" close-text="知道了"></el-alert>
      <h3>{{pageData.news_title}}</h3>
      <div class="content-box" v-html="pageData.content"></div>
    </div>
    <pub-foot></pub-foot>
  </div>
</template>
<script>
import pubHead from "../Public/head";
import pubsNav from "../Public/nav";
import pubFoot from "../Public/foot";
export default {
  components: {
    pubHead,
    pubsNav,
    pubFoot
  },
  data() {
    return {
      pageData: {}
    };
  },
  methods: {
    getData(id) {
      //获取单页信息
      let data = {}
      if (this.$route.query.ifview) {
        data.ifview = this.$route.query.ifview
      }
      data.id = id
      this.$db.post(this.$db.config.newsPageDetails, data).then(res => {
        this.pageData = res.data;
      });
    }
  },
  watch: {
    $route: function(val) {
      if (val) {
        this.getData(val);
      }
    }
  },

  created() {
    if (this.$route.query.id) {
      this.getData(this.$route.query.id);
    }
  }
};
</script>

<style lang="scss" scoped>
#about-intd {
  width: 100%;
}
.content-box /deep/ img {
  max-width: 96% !important;
}
.intd-box {
  width: 1300px;
  margin: 50px auto;
  > h3 {
    font-size: 30px;
    color: #333333;
    text-align: center;
    margin-bottom: 66px;
  }
  > p {
    font-size: 16px;
    line-height: 32px;
    color: #333333;
    margin-bottom: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/view_page.vue